import * as d3 from 'd3';

export const drawChart = (pct, id, txt) => {
	const dataset = [
		{label: "others", count: (100-pct)},
		{label: "you", count: pct}
	];
	let myoffset = -1*((dataset[0].count/100)*Math.PI) ;
	if (txt !== "lowest") {
		myoffset = myoffset + Math.PI;
	}
	const width = 150;
	const height = 150;
	const radius = Math.min(width,height)/2;
	const svg = d3.select("#" + id).append('svg').attr('width',width).attr('height',height);
	const g = svg.append("g").attr("transform", "translate(" + width/2 + "," + height/2 + ")");
	const color = d3.scaleOrdinal().domain(["others", "you"]).range(['#dddddd','#0277bd']);
	const pie = d3.pie().sort(null).value(d => d.count);
	const path = d3.arc().innerRadius(0).outerRadius(radius).startAngle(d => d.startAngle + myoffset).endAngle(d=> d.endAngle + myoffset);
	const label = d3.arc().outerRadius(radius*(2/3)).innerRadius(radius*(2/3)).startAngle(d => d.startAngle + myoffset).endAngle(d => d.endAngle + myoffset);
	const arc = g.selectAll(".arc").data(pie(dataset)).enter().append("g").attr("class","arc");
	arc.append("path").attr("d", path).attr("fill", d => color(d.data.label));
	arc.append("text").attr("id", d => id + "-" + d.data.label)
		.attr("transform", d => {
			let thiscent = label.centroid(d);
			// console.log(thiscent);
			if ( d.data.count < 50 ) {
				thiscent[1] = -.8*thiscent[1];
			} else if (txt === "lowest") {
				thiscent[1] = thiscent[1]/1.5;
				thiscent[0] = -5;
			} else {
				thiscent[1] = thiscent[1]/3;
			}
			return "translate(" + thiscent + ")";
		})
		.text(d => {
			let prefix = "";
			if (d.data.label === "you") {
				if (txt) {
					// console.log(txt);
					prefix = txt + " ";
				}
				return prefix + d.data.count + "%";
			} else {
				return "";
			}
		})
		.attr("class", (d) => {
			if (d.data.count < 50) {
				return "lowpct"
			} else { return "highpct"}
		});
	const youlabel = d3.select("#"+id+"-you");
	const bbox = youlabel.node().getBBox();
	youlabel.attr("dx",-1*(bbox.width)/2.25);
};
